/* eslint-disable */
export default {
  'signixfrontend': '23db77682ee82c6231cf592d3b3e78788a529e11e3fdb8b98b161dc607a33990',
  '@signiapp/core': '1.5.239',
  '@signiapp/helpers': '0.3.10',
  '@signicat/designi': '^0.5.44',
};
